<template>
  <div class="home container" ref="home">
    <div class="preFilters" v-html="prefilterhtml"></div>
  </div>
</template>

<script>
  export default {
    name: "Home",
    props: {
      prefilterhtml: HTMLDivElement,
    },
    mounted() {
      this.updateHeight()
    },
    methods: {
      updateHeight() {
        const height = this.$refs.home.clientHeight

        this.$emit('heightChanged', height)
      },
    }
  };
</script>

<style lang="scss">
  .preFilters {
    @media (max-width:991px) {
      position:relative;
      overflow-x:scroll;

      .row {
        width: 1500px;
        height: 90px;
      }
      .card {
        height: 170px;
        margin-left: 0px;
      }
    }
  }
</style>